import React from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import Slider from "Shared/Slider";
import { analyticsFEA } from "src/AnalyticsFEA";
import { ApplicationStore } from "src/store";
import { patchPaymentsRequest } from "src/store/actions/payments";
import { getSelectedPaymentTerm, getSelectedPaymentTermOptions, getVehicle } from "src/store/selectors/vehicles";

interface Props {
    vin: string;
    paymentType: "loan" | "lease";
}

const Term = ({
    vin,
    paymentType,
    termOptions,
    termValue,
    uuid,
    vehicle,
    patchPayments,
}: Props & ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps) => {
    const { t } = useTranslation();

    const handleChange = (index: number) => {
        patchPayments(
            uuid,
            vin,
            {
                [paymentType]: {
                    term: termOptions[index],
                },
            },
            "set_term_length"
        );

        analyticsFEA.engine.calculationStart(uuid, [vehicle]);
    };

    return (
        <div className="CalculatorSlider">
            <div className="CalculatorSlider__container--input">
                <input
                    value={`${termValue} ${t("CustomizePayment.PaymentFields.Sliders.Term.months")}`}
                    className="CalculatorSlider__input"
                    disabled={true}
                />
            </div>
            <div className="CalculatorSlider__container--slider">
                <Slider
                    className="TermSlider"
                    min={0}
                    max={termOptions.length - 1}
                    sliderValue={termOptions.indexOf(termValue)}
                    step={1}
                    onChange={handleChange}
                    ticks={termOptions}
                    tickLabel=""
                    tickPrefix=""
                    controlled={true}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state: ApplicationStore, { vin }: Props) => {
    return {
        vehicle: getVehicle(state, vin),
        termOptions: getSelectedPaymentTermOptions(state, vin),
        termValue: getSelectedPaymentTerm(state, vin),
        uuid: state.deal.uuid!,
    };
};

const mapDispatchToProps = {
    patchPayments: patchPaymentsRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(Term);
